const SESSION_KEY = 'x-session-id';
const SESSION_LAST_ACTIVITY_KEY = 'x-session-last-activity';
const VISITOR_KEY = 'x-visitor-id';
const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

const createId = (): string => {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const getAnalyticsSessionId = (): string => {
  const now = Date.now();
  const lastActivity = Number(sessionStorage.getItem(SESSION_LAST_ACTIVITY_KEY) ?? 0);
  let sessionId = sessionStorage.getItem(SESSION_KEY);

  if (!sessionId || !lastActivity || now - lastActivity > SESSION_TIMEOUT_MS) {
    sessionId = createId();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  sessionStorage.setItem(SESSION_LAST_ACTIVITY_KEY, String(now));
  return sessionId;
};

export const getAnalyticsVisitorId = (): string => {
  let visitorId = localStorage.getItem(VISITOR_KEY);
  if (!visitorId) {
    visitorId = createId();
    localStorage.setItem(VISITOR_KEY, visitorId);
  }
  return visitorId;
};
